import { render, staticRenderFns } from "./svgCom.vue?vue&type=template&id=63985748&"
import script from "./svgCom.vue?vue&type=script&lang=js&"
export * from "./svgCom.vue?vue&type=script&lang=js&"
import style0 from "./svgCom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports